import { Controller, useFormContext } from "react-hook-form";
import { ErrorMessage, Toggle, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { CompaniesFormData } from "../../types";

export const EnableInvoicingField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CompaniesFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography>Enable Invoicing?</Typography>
      <Controller
        name="enableInvoicing"
        control={control}
        render={({ field }) => (
          <div className="flex items-center gap-4">
            <Toggle checked={field.value} onChange={(checked) => field.onChange(checked)} />
            <Typography className="inline">{field.value ? "Yes" : "No"}</Typography>
          </div>
        )}
      />
      <ErrorMessage errors={errors} name="enableInvoicing" />
    </div>
  );
};
